<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-toolbar color="#313a46">
          <v-card-title class="text-h5 white--text">Cadastrar</v-card-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field v-model="itensForm.id" label="Código Serviço"></v-text-field>
                </v-col>
          
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined class="white--text btn-form" color="error" @click="closeModal('close')">FECHAR</v-btn>
          <v-btn
            class="white--text mr-5 btn-form"
            color="#313a46"
            @click="createCodigoServico()"
          >Cadastrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import toast from "@/commom/toast";
import codigoServicoG4 from "@/services/http/rpa/CodigosServicoG4.js";
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    labelBtn: {
      type: String
    },
    itemModal: {
      type: Object
    }
  },

  data() {
    return {
      itensForm: {
        cnpj: ""
      },
      status: [
        { text: "Ativo", value: "true" },
        { text: "Inativo", value: "false" }
      ],
      segmento: [
        { text: "2 Rodas", value: "2" },
        { text: "4 Rodas", value: "4" }
      ],
      rules: {
        required: value => !!value || "Campo obrigatório.",
        maxNumber: value =>
          value.length == 18 || `O campo deve conter 14 digitos`
      }
    };
  },

  methods: {
    async createCodigoServico() {
      if (this.$refs.form.validate()) {
        const sendForm = { ...this.itensForm };
        sendForm.id = this.itensForm.id.replace(/\D/g, "");
        try {
          await codigoServicoG4().store(sendForm);
          toast("success", "Cadastrado com sucesso");
        } catch (e) {
          toast("error", e.message);
        } finally {
          this.closeModal("refresh");
          this.$refs.form.reset();
        }
      }
    },

    closeModal(value) {
      this.$emit("close", value);
    }
  }
};
</script>

<style>
</style>